/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/tag'
export default icon
